import { PresentationSlides } from '@core/presentation-panel';
import { ClientType, VideoLayout } from '@core/types';
import { LoaderPage, TestWebinarBadge } from '@core/ui';
import { useParams } from '@online-webinar/router';
import { joinWebinar, leaveWebinar, useAppDispatch, useAppSelector } from '@online-webinar/store';
import { useEffect } from 'react';

export const SlideController = () => {
    const dispatch = useAppDispatch();

    const { webinarId } = useParams({ strict: false });
    const isInitialized = useAppSelector((state) => state.liveWebinar.isInitialized);
    const activeSlideNumber = useAppSelector((state) => state.liveWebinar.activeSlideNumber);
    const slideDeck = useAppSelector((state) => state.liveWebinar.slideDeck);
    const isTest = useAppSelector((state) => state.liveWebinar.webinarData.isTest);

    useEffect(() => {
        document.body.classList.add('no-menu');
        return () => {
            document.body.classList.remove('no-menu');
        };
    }, []);

    // Send Join Webinar
    useEffect(() => {
        dispatch(joinWebinar({ webinarId: webinarId!, clientType: ClientType.slide_controller }));
        return () => {
            dispatch(leaveWebinar());
        };
    }, []);

    if (!isInitialized) {
        return <LoaderPage />;
    }

    return (
        <div className="menu:h-dvh">
            {isTest && <TestWebinarBadge classNames="fixed top-2 left-2 z-50" />}
            <PresentationSlides
                slides={slideDeck?.slides ?? []}
                currentSlideNumber={activeSlideNumber ?? 0}
                totalSlides={slideDeck?.slides?.length ?? 0}
                showFullScreen="hidden"
                videoLayout={VideoLayout.PresentationWithVideoSmall}
                isController
            />
        </div>
    );
};
